<template>
  <el-menu-item class="el-submenu-pop" :index="'' + index" v-if="!items.children || items.children.length === 0">{{
    options.liTextLimit === true ? items.label.substr(0, options.liTextLimitCount) : items.label
  }}</el-menu-item>
  <el-submenu
    :popper-append-to-body="false"
    :popper-class="$event.getIdsByStrId(myid) + '-' + index"
    v-else-if="items.children && items.children.length > 0"
    :index="'' + index"
    @click.native = "handleMenuClick(index,items)"
  >
    <template slot="title">
      <template>
        <span v-if="options.liIconPosition === undefined && options.iconPosition === 'right'">{{ items.label }}</span>
        <span v-if="options.liIconPosition !== undefined && options.liIconPosition === 'right'">{{ options.liTextLimit ? items.label.substr(0, options.liTextLimitCount) : items.label }}</span>

        <cxIcon class="icon old-icon-style" v-if="options.liIconType === undefined && options.iconType === 'icon'" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <cxIcon class="icon" v-if="options.liIconType !== undefined && options.liIconType === 'icon' && options.showLiIcon !== false" :options="options" :iconStyle="getIconStyle" iconSrcName="liIconSrc"></cxIcon>

        <img
            class="icon"
            v-else-if="options.liIconType === undefined && options.iconType === 'img' && options.iconSrc"
            :src="options.iconSrc"
            :style="getIconImgStyle"
        />
        <img
            class="icon"
            v-else-if="options.liIconType !== undefined && options.liIconType === 'img' && options.liIconSrc && options.showLiIcon !== false"
            :src="options.liIconSrc"
            :style="getIconImgStyle"
        />

        <span v-if="options.liIconPosition === undefined && options.iconPosition === 'left'">{{ items.label }}</span>
        <span v-if="options.liIconPosition !== undefined && options.liIconPosition === 'left'">{{ options.liTextLimit ? items.label.substr(0, options.liTextLimitCount) : items.label }}</span>

      </template>
    </template>
    <cx-menu-tree
      v-for="(child_option, child_index) in items.children"
      :key="child_index"
      :items="child_option"
      :myid="myid"
      :popper-append-to-body="false"
      :index="index + '_' + child_index"
      :options="options"
      @handleMenuClick="handleMenuClick"
    ></cx-menu-tree>
  </el-submenu>
</template>

<script>
export default {
  name: "cx-menu-tree",
  props: {
    myid: {
      type: Object,
      required: true
    },
    items: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    ifOldPageData() {
      //  判断是否是旧页面数据
      if (this.options.showLiIcon === undefined) {
        return true
      } else {
        return false
      }
    },
    getFixToRightStyle() {
      if(this.options.liIconPosition === undefined){
        if (this.options.iconPosition === "right") {
          return {
            position: "absolute",
            right: "10px",
            top: "50%"
            // marginTop: -this.options.iconWidth / 2 + "px"
          }
        } else {
          return {}
        }
      }else{
        if (this.options.liIconPosition === "right") {
          return {
            // position: "absolute",
            // right: "10px",
            // top: "50%",
            // transform: "translateY(-50%)",
            display: "inline-block",
            marginLeft: this.options.liIconMargin + "px"
          }
        } else {
          return {
            display: "inline-block",
            marginRight: this.options.liIconMargin + "px"
          }
        }
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getMargin() {
      return this.options.liIconPosition === "left"
        ? `${this.options.liIconWidth / 2}px ${this.options.liIconMargin}px 0 0`
        : `${this.options.liIconWidth / 2}px 0 0 ${this.options.liIconMargin}px`
    },
    getIconStyle() {
      //颜色
      let color = ""
      if(this.options.liIconColor === undefined){
        // color = this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.iconColor && this.options.iconColor.color
        //   ? this.options.iconColor.color
        //   : this.options.iconColor
        color = this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        })
      }
      else{
        // color = this.options.liIconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.liIconColor && this.options.liIconColor.color
        //     ? this.options.liIconColor.color
        //     : this.options.liIconColor
        color = this.$parseColor(this.options.liIconColor, {
          isThemeColor: this.options.liIconColorIsThemeColor
        })
      }
      //字号
      let fontSize = 12
      if(this.options.liIconWidth === undefined ){
        fontSize = this.options.iconWidth
      }
      else{
        fontSize = this.options.liIconWidth
      }
      return {
        ...this.getFixToRightStyle,
        "--color": color,
        fontSize: fontSize + "px",
        width: fontSize + "px",
        height: fontSize + "px"
      }
    },
    getIconImgStyle() {
      let width = 0
      if(this.options.liIconWidth === undefined){
        width = this.options.iconWidth
      }else{
        width = this.options.liIconWidth
      }
      return {
        ...this.getFixToRightStyle,
        width: width + "px"
      }
    },
  },
  methods: {
    handleOpen() {
      console.log(arguments, "open")
    },
    handleClose() {
      console.log(arguments, "close")
    },
    handleMenuClick(index,items){
      this.$emit("handleMenuClick",index,items)
    }
  },
  created() {}
}
</script>

<style scoped>
::v-deep .el-submenu__title svg * {
  stroke: var(--color);
}
</style>
